module.exports = __webpack_public_path__ + "img/across shoulders.9f4f5973.png";